// bootstrap-vue-next closes BModal/BOffcanvas via two separate click
// handlers: the outer .modal/.offcanvas wrapper (guarded with Vue's `.self`
// modifier, so clicks bubbling up from dialog content don't trigger it) and
// the .modal-backdrop/.offcanvas-backdrop element sitting behind it (with NO
// such guard - any click on it closes, no matter where the drag started).
// A text-selection drag that starts inside the dialog and releases outside
// it produces a native click on whichever of those is topmost at the
// mouseup point, closing the modal either way. The old (Vue 2) bootstrap-vue
// tracked mousedown separately to guard against exactly this;
// bootstrap-vue-next doesn't.
//
// Fix: while a mousedown is active inside a dialog, disable pointer-events on
// both the wrapper and the backdrop, so a drag that ends up over either can't
// be hit-tested as a close click - it just falls through to whatever's
// behind them. The dialog itself is explicitly kept interactive throughout,
// since pointer-events: none is inherited by descendants otherwise. Genuine
// clicks on the wrapper/backdrop (mousedown starts there, not inside the
// dialog) are unaffected.
export const preventBackdropDragClose = () => {
	const setBackdropInteractive = (interactive) => {
		document
			.querySelectorAll('.modal.show, .offcanvas.show, .modal-backdrop, .offcanvas-backdrop')
			.forEach((el) => {
				el.style.pointerEvents = interactive ? '' : 'none';
			});
		document.querySelectorAll('.modal-dialog, .offcanvas-body').forEach((dialog) => {
			dialog.style.pointerEvents = interactive ? '' : 'auto';
		});
	};

	document.addEventListener(
		'mousedown',
		(event) => {
			if (event.target.closest('.modal-dialog, .offcanvas-body')) {
				setBackdropInteractive(false);
			}
		},
		true
	);

	document.addEventListener(
		'mouseup',
		() => {
			setBackdropInteractive(true);
		},
		true
	);
};
